<template>
    <ui-modal :title="title" :close="() => { close(); afterClose?afterClose():null; }" ref="modal">
        <template #icon>
            <div
                class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-blue-100 sm:mx-0 sm:h-10 sm:w-10">
                <svg class="h-6 w-6 text-blue-500" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                     stroke="currentColor" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                          d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                </svg>
            </div>
        </template>
        <div>
            <div class="grid gap-1 grid-cols-12">
                <ui-input label="Your Name" name="name"
                          v-model="form.name"
                          class="xl:col-span-12"></ui-input>
                <div class="col-span-full">
                    <label class="block text-sm font-medium text-gray-700 mb-1">Rejection Comments</label>
                    <div class="max-h-96 overflow-scroll border-gray-300 border rounded-md text-xs px-0 py-0"
                         v-if="noRejectData">
                        <div class="py-2 mx-2">
                            <span class="font-semibold">No specific rejection comments given</span>
                        </div>
                    </div>
                    <div class="max-h-96 overflow-scroll border-gray-300 border rounded-md text-xs px-0 py-0" v-else>
                        <div v-for="(paragraph,index) in rejectData.paragraphs"
                             class="py-2 mx-2 border-b border-gray-200"
                             v-if="paragraph">
                            <div>
                                <span class="font-semibold" v-text="rams.paragraphs[index].title"></span>
                                <span class="text-xs" v-text="' (Paragraph '+index+')'"></span>
                            </div>
                            <div class="text-red-500 whitespace-pre-wrap" v-text="paragraph">
                            </div>
                        </div>
                        <div v-for="(risk,index) in rejectData.healthRisks" v-if="risk"
                             class="py-2 mx-2 border-b border-gray-200">
                            <div>
                                <span class="font-semibold" v-text="rams.healthRisks[index].hazard"></span>
                                <span class="text-xs" v-text="' (Health Risk '+index+')'"></span>
                            </div>
                            <div class="text-red-500 whitespace-pre-wrap" v-text="risk">
                            </div>
                        </div>
                        <div v-for="(risk,index) in rejectData.safetyRisks" v-if="risk"
                             class="py-2 mx-2 border-b border-gray-200">
                            <div>
                                <span class="font-semibold" v-text="rams.safetyRisks[index].hazard"></span>
                                <span class="text-xs" v-text="' (Safety Risk '+index+')'"></span>
                            </div>
                            <div class="text-red-500 whitespace-pre-wrap" v-text="risk">
                            </div>
                        </div>
                    </div>
                </div>
                <ui-textarea
                    label="Any other reasons to why you rejecting this RAMS?"
                    autoresize
                    rows="3"
                    field="resize-none"
                    name="content"
                    v-model="form.comment"
                ></ui-textarea>
            </div>
        </div>
        <template #footer-primary>
            <span class="mt-0 flex w-full sm:mt-0 sm:w-auto">
                <ui-button-new primary class="w-full whitespace-nowrap"
                               :loading="form.busy || (!form.name || (form.name.length===0)) || (noRejectData && (!form.comment || (form.comment.length===0)))"
                               @click="form.submit()"
                               v-text="button"></ui-button-new>
            </span>
        </template>
    </ui-modal>
</template>

<script>
import RamsFields from "../RamsFields.vue";
import UiDatePicker from "../../../ui/UiDatePicker.vue";
import UiTextarea from "../../../ui/UiTextarea.vue";
import UiFormSection from "../../../ui/UiFormSection.vue";

export default {
    components: {UiFormSection, UiTextarea, UiDatePicker, RamsFields},
    props: {
        handle: Function,
        handle2: Function,
        handle3: Function,
        close: Function,
        afterClose: Function,
        title: '',
        paragraphs: {
            type: Array,
            default: () => [
                'Are you sure you want to proceed?',
            ],
        },
        rams: Object,
        rejectData: Object,
        button: '',
    },
    computed: {
        noRejectData() {
            return !(this.rejectData.paragraphs.filter(p => p).length || this.rejectData.healthRisks.filter(p => p).length || this.rejectData.safetyRisks.filter(p => p).length)
        }
    },
    data() {
        return {
            form: new Form({}, async (form) => {
                await this.handle(form)
                this.close()
            }),
        }
    },
    methods: {},
    mounted() {
    }
}
</script>
